import React from "react";
import StoryCard from "./StoryCard";
import "./TopTenRow.css";

export default function TopTenRow({ stories }) {
  const topTen = stories.slice(0, 10); // temporary placeholder

  return (
    <section className="topten-row">
      <h2 className="topten-row-title">Top 10 do Momento</h2>

      <div className="topten-row-list">
        {topTen.map((story, index) => (
          <div key={story.id} className="topten-item">
            {/* Giant number */}
            <div className="topten-number">
              {index + 1}
            </div>

            {/* Story Card */}
            <StoryCard story={story} />
          </div>
        ))}
      </div>
    </section>
  );
}
